import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import cssTransition from 'ember-css-transitions/modifiers/css-transition';
import classNames from 'volta/helpers/class-names';
import { t } from 'ember-intl';
import BvSpinner from 'volta/components/bv-spinner';
import type { IResourceName } from 'volta/models/base-model';
import type { TOC } from '@ember/component/template-only';
import lowerCase from 'lodash/lowerCase';
interface BvCollectionLoaderSignature {
    Args: {
        absolute?: boolean;
        resourceName?: IResourceName;
    };
}
const BvCollectionLoaderComponent: TOC<BvCollectionLoaderSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <div
    class={{classNames 'bv-collection-loader' (if @absolute 'bv-collection-loader--absolute')}}
    {{cssTransition 'bv-collection-loader'}}
  >
    <div class='bv-collection-loader-panel'>
      <div class='bv-collection-loader-panel-row'>
        <BvSpinner @size='sm' @intent='primary' />
        <span class='bv-collection-loader-panel-text'>
          {{t
            'bvList.loading'
            resourceNamePlural=(lowerCase (t (if @resourceName @resourceName.plural 'items')))
          }}
        </span>
      </div>
    </div>
  </div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BvCollectionLoaderComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        BvCollectionLoader: typeof BvCollectionLoaderComponent;
        'bv-collection-loader': typeof BvCollectionLoaderComponent;
    }
}
